import { useNotifications as _useNotifications } from '@hwm/ui-lib';
import { ErrorMsgToDisplayFn } from '@shared/models';

export const useNotifications = () => {
  const notifications = _useNotifications(ErrorMsgToDisplayFn());

  return {
    handleSuccess: notifications.handleSuccess,
    handleError: notifications.handleError,
    handleWarning: notifications.handleWarning,
  };
};
